import {isNil, map, omitBy} from 'lodash';
import TimeSensitiveItemTypeService from 'src/services/TimeSensitiveItemTypeService';
import {changesSaved, errorMessage} from 'shared/actions/notifications';
import browserHistory from 'shared/history';

export const fetchTimeSensitiveItemTypes = (sponsorId, scholarshipProgramId, globalItems) => () =>
  TimeSensitiveItemTypeService.index({sponsorId, scholarshipProgramId, globalItems});

const fields = [
  'title',
  'question',
  'description',
  'details',
  'detailedDescription',
  'emoji',
  'socialNote',
  'socialNumber',
  'completedAtText',
  'sponsorId',
  'displayOpportunityCard',
  'testimonials',
].join(',');

export const fetchTimeSensitiveItemType = (id) => () =>
  TimeSensitiveItemTypeService.show(id, {fields});

export const saveTimeSensitiveItemType = (id, data) =>
  TimeSensitiveItemTypeService.update(id, data);

// sending in nil data for fields that don't exist on the detail types or testimonials causes errors
// for ex, sending in "minimum_number: nil" causes PhotoDetail to error on save
const removeNilValues = (timeSensitiveItemType, fieldArray) =>
  map(timeSensitiveItemType[fieldArray], (field) => omitBy(field, (value, _) => isNil(value)));

const formattedData = (data) => {
  data.details = removeNilValues(data, 'details');
  data.testimonials = removeNilValues(data, 'testimonials');

  return data;
};

export const createOrUpdateTimeSensitiveItemType = (data) => (dispatch) =>
  TimeSensitiveItemTypeService.createOrUpdate(formattedData(data))
    .then((item) => {
      dispatch(changesSaved());
      return browserHistory.push(`/admin/tools/time-sensitive-item-types/${item._id}`);
    })
    .catch(() => {
      dispatch(errorMessage('Time Sensitive Item type was not saved'));
    });
